<!-- MODAL HEADER-->
<div class="row modal-bar">
  <div class="col-sm-9">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>
  <div class="col-sm-3">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="form" class="form-content">
  <div class="section-wrapper">
    <div class="form-layout">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.NAME' | translate}} <span class="tx-danger">*</span></label>
            <input class="form-control" formControlName="Name" placeholder="{{'TENANT-SHOPS.EDITDIALOG.FORM.PLACEHOLDER.NAME' | translate}}" maxlength="256">
            <t4-display-validation controlName="Name" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.DOMAIN' | translate}} <span class="tx-danger">*</span></label>
            <ng-select [items]="tenantShopDomains" bindLabel="Name" bindValue="Id" [clearable]="false" notFoundText="{{ 'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body" formControlName="TenantShopDomainId"></ng-select>
            <t4-display-validation controlName="TenantShopDomainId" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>
      </div>

      <div class="row">
        <div fxFlex class="mt-1 col-lg-6">
          <input type="checkbox" class="me-2" formControlName="IsRegistrationOpenForNewMembers">
          <label class="form-check-label" for="active">{{'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.REGISTRATION-CHECK' | translate}}</label>
        </div>

        @if (this.form.value.IsRegistrationOpenForNewMembers) {
          <div class="col-lg-6">
            <div class="form-group">
              <label class="form-control-label">{{'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.REGISTRATION-TYPE' | translate}}</label>
              <ng-select [items]="registrationTypeEnum" bindLabel="text" bindValue="value" [clearable]="false" notFoundText="{{ 'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body" formControlName="RegistrationTypeId">
                <ng-template ng-label-tmp let-item="item">
                  {{ 'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.REGISTRATION-TYPE.' + (item.text | uppercase) | translate }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ 'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.REGISTRATION-TYPE.' + (item.text | uppercase) | translate }}
                </ng-template>
              </ng-select>
              <t4-display-validation controlName="RegistrationTypeId" [form]="form" [messages]="validationMessages"></t4-display-validation>
            </div>
          </div>
        }
      </div>

      @if (this.form.value.IsRegistrationOpenForNewMembers) {
        <div class="col-lg-12">
          <t4-date-time-control formControlName="RegistrationOpenForNewMembers" [labelDate]="'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.REGISTRATION-DATE'" [labelTime]="'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.REGISTRATION-TIME'"></t4-date-time-control>
        </div>
      }

      <div class="row">
        <div fxFlex class="mt-1 mb-2 col-lg-12">
          <input type="checkbox" class="me-2" formControlName="AllowAccountActivation">
          <label class="form-check-label" for="allowAccountActivation">{{'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.ALLOW-ACCOUNT-ACTIVATION' | translate}}</label>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-lg-12 title-container">
          <h6 class="section-title">{{'TENANT-SHOPS.EDITDIALOG.FORM.SECTION.SOCIAL-SHARING' | translate}}</h6>
          <p class="text-muted small">{{'TENANT-SHOPS.EDITDIALOG.FORM.SECTION.SOCIAL-SHARING-DESCRIPTION' | translate}}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.TITLE' | translate}}</label>
            <input class="form-control" formControlName="Title" placeholder="{{'TENANT-SHOPS.EDITDIALOG.FORM.PLACEHOLDER.TITLE' | translate}}" [attr.maxlength]="titleMaxLength">
            <div class="small-container">
              <small [ngClass]="getTitleStatusClass()">{{ getTitleCharactersText() }}</small>
              <small class="form-text text-muted d-block">
                {{'TENANT-SHOPS.EDITDIALOG.FORM.HELP.TITLE' | translate:{ min: titleRecommendedMin, max: titleRecommendedMax, limit: titleMaxLength } }}
              </small>
            </div>

            <t4-display-validation controlName="Title" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.DESCRIPTION' | translate}}</label>
            <textarea class="form-control" formControlName="Description" rows="3" placeholder="{{'TENANT-SHOPS.EDITDIALOG.FORM.PLACEHOLDER.DESCRIPTION' | translate}}" [attr.maxlength]="descriptionMaxLength"></textarea>
            <div class="small-container">
              <small [ngClass]="getDescriptionStatusClass()">{{ getDescriptionCharactersText() }}</small>
              <small class="form-text text-muted d-block">
                {{'TENANT-SHOPS.EDITDIALOG.FORM.HELP.DESCRIPTION' | translate:{ min: descriptionRecommendedMin, max: descriptionRecommendedMax, limit: descriptionMaxLength } }}
              </small>
            </div>
            <t4-display-validation controlName="Description" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-10">
          <div class="form-group">
            <label class="form-control-label">{{'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.IMAGE' | translate}}</label>
            <input class="form-control" formControlName="ImageUrl" placeholder="{{'TENANT-SHOPS.EDITDIALOG.FORM.PLACEHOLDER.IMAGE' | translate}}">
            <small class="form-text text-muted">
              {{'TENANT-SHOPS.EDITDIALOG.FORM.HELP.IMAGE' | translate}}
            </small>
            <t4-display-validation controlName="ImageUrl" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label class="form-control-label">{{'TENANT-SHOPS.EDITDIALOG.FORM.LABEL.IMAGE-PREVIEW' | translate}}</label>
            <div class="image-preview-container">
              <img [src]="form.get('ImageUrl')?.value" class="img-fluid img-thumbnail" style="max-height: 200px;" alt="Preview">
            </div>
          </div>
        </div>
      </div>

      <div class="form-layout-footer row">
        <div class="col-6">
          <button (click)="submit()" [disabled]="form.invalid || saving" class="btn btn-block btn-primary bd-0"><i class="far fa-save"></i><span>{{ 'GENERIC.BUTTON.SAVE' | translate }}</span></button>
        </div>
        <div class="col-6">
          <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0"><i class="fas fa-ban"></i><span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span></button>
        </div>
      </div>

    </div>

  </div>
</form>